// M-166: セグメント条件「クーポンの保有状態」の判定材料を coupon_usages から組み立てる純関数。
// tenant-promo（人数プレビュー / 顧客一覧）と functions（runSegmentPush の宛先解決）の双方から
// 参照する単一の真実源。Web/Node SDK 依存は持たない（クエリは呼出元が行い、doc 配列を渡す）。
import { resolveCouponRedeemCount } from './couponHolding.js';
/** Firestore `in` 句の上限に合わせた分割幅（呼出元のクエリ分割用 / 10 で固定）。 */
export const COUPON_IDS_QUERY_CHUNK = 10;
/** `couponIds` を `in` 句の上限で分割する（空配列は空 / 重複は除く / 非破壊）。 */
export function chunkCouponIds(couponIds, size = COUPON_IDS_QUERY_CHUNK) {
    const unique = [...new Set(couponIds.filter((id) => typeof id === 'string' && id))];
    const out = [];
    for (let i = 0; i < unique.length; i += size)
        out.push(unique.slice(i, i + size));
    return out;
}
/**
 * 1 件の usage が `state` に合致するか。
 *
 * 判定順は `classifyCouponHolding` と同じ **status → 回数**（期間は見ない = 期限切れでも
 * 「取得した」事実は変わらず、事後配信の母集団に含める）。
 * - `delivered`（未取得）はどの state にも入らない
 * - 使用回数は `resolveCouponRedeemCount`（旧 doc = `redeemed` なら 1 回）
 */
export function matchesCouponHoldingState(usage, state) {
    if (usage.status === 'delivered')
        return false;
    const redeemed = resolveCouponRedeemCount(usage) >= 1;
    switch (state) {
        case 'claimed_unused':
            return !redeemed;
        case 'claimed':
            return true;
        case 'redeemed':
            return redeemed;
    }
}
/**
 * `segment.couponHolding` に合致する lineUserId の集合を作る。
 *
 * 同じ人が複製クーポンを複数枚持つ（参加賞 #03 と #07 など）場合は**人単位**でまとめる:
 * - `claimed_unused` … 1 枚でも未使用があれば含める（未使用のクーポンを持っている人）
 * - `claimed`        … 1 枚でも取得していれば含める
 * - `redeemed`       … 1 枚でも使っていれば含める
 * `couponIds` 以外の usage は無視する（呼出元のクエリが広くても結果は変わらない）。
 */
export function resolveCouponHolderIds(usages, spec) {
    const target = new Set(spec.couponIds);
    const out = new Set();
    for (const u of usages) {
        if (!target.has(u.couponId) || !u.lineUserId)
            continue;
        if (matchesCouponHoldingState(u, spec.state))
            out.add(u.lineUserId);
    }
    return out;
}
//# sourceMappingURL=couponHoldingSegment.js.map